(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("checkoutStep1Register", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/checkout/checkoutStep1RegisterView.html",
            controller: ["authService", "checkoutService", "publicResource", "frameworkService", "messageService", "shoppingCartService", "sessionService", "organizationsFilterResource", "REG_EXP", "$q", "$state", "$translate", CheckoutStep1RegisterCtrl],
            controllerAs: "vm"
        };
        function CheckoutStep1RegisterCtrl(authService, checkoutService, publicResource, frameworkService, messageService, shoppingCartService, sessionService, organizationsFilterResource, REG_EXP, $q, $state, $translate) {
            var vm = this;
            checkoutService.setStep(1);
            if (authService.authentication.isAuth) {
                $state.go("main.checkout.step2", {}, { location: "replace" });
                checkoutService.wizard.isStep1Valid = true;
                return;
            }
            vm.frameworkData = frameworkService.data;
            vm.userType = "haveAccount";
            vm.nextButtonText = "common.next";
            vm.showErrors = false;
            vm.passwordPattern = REG_EXP.password;
            vm.emailPattern = REG_EXP.email;
            //Organizations
            vm.showOrganizationFieldset = vm.frameworkData.tenantFeatures.organization
                && (vm.frameworkData.tenant.tenantFeaturesSelfRegistrationOrgSignUpCodeEnabled
                    || vm.frameworkData.tenant.tenantFeaturesOrganizationDropdown);
            vm.showSignupCodeNote = vm.frameworkData.tenantFeatures.organization && vm.frameworkData.tenant.tenantFeaturesSelfRegistrationOrgSignUpCodeEnabled && !vm.frameworkData.tenant.tenantFeaturesOrganizationDropdown;
            vm.showSignupCodeDropdownNote = vm.frameworkData.tenantFeatures.organization && vm.frameworkData.tenant.tenantFeaturesSelfRegistrationOrgSignUpCodeEnabled && vm.frameworkData.tenant.tenantFeaturesOrganizationDropdown;
            vm.showAddOrganizationNote = vm.frameworkData.tenantFeatures.organization && vm.frameworkData.tenant.tenantFeaturesUserCanAddOrganization && vm.frameworkData.tenant.tenantFeaturesOrganizationDropdown;
            vm.orgSearch = "";
            vm.showOtherOrganization = false;
            vm.organizations = [];
            vm.checkSpecialCharacter = function (password) {
                if (password)
                    return REG_EXP.specialCharacterPassword.test(password);
                return true;
            };
            vm.checkEmailExists = function (email) {
                return $q(function (resolve, reject) {
                    publicResource.emailExists({ actionValue: email }, function (result) {
                        if (!result.value)
                            resolve(true);
                        else
                            reject();
                    }, function (error) {
                        messageService.error(error);
                    });
                });
            };
            vm.refreshOrganizations = function (val) {
                vm.orgSearch = val;
                organizationsFilterResource.getCachedEnabled({ name: val }, function (result) {
                    vm.organizations = result;
                    if (vm.frameworkData.tenantFeatures.organization && vm.frameworkData.tenant.tenantFeaturesUserCanAddOrganization) {
                        vm.organizations.push({ name: $translate.instant('public.selfRegistration.addOrganization'), id: -1 });
                    }
                });
            };
            vm.refreshOrganizations("");
            vm.onSelect = function (item) {
                vm.createAccount.organizationName = vm.orgSearch;
                vm.createAccount.organization = item;
                vm.createAccount.organizationId = item.id;
                vm.showOtherOrganization = item.id == -1;
            };
            vm.organizationChanged = function () {
                vm.createAccount.organizationId = null;
                vm.createAccount.organizationName = "";
            };
            vm.signupCodeChanged = function () {
                vm.createAccount.organizationId = null;
                vm.createAccount.organizationName = "";
                vm.organizationName = "";
                if (vm.createAccount.signupCode) {
                    publicResource.getOrganizationNameBySignupCode({
                        actionValue: vm.createAccount.signupCode
                    }, function (result) {
                        vm.organizationName = result.value;
                    }, function () {
                        messageService.error("common.genericError");
                    });
                }
            };
            vm.checkSignupCode = function (code) {
                return $q(function (resolve, reject) {
                    if (typeof (code) === 'undefined' || code === '') {
                        resolve(true);
                    }
                    else {
                        publicResource.isSignupCodeValid({ actionValue: code }, function (result) {
                            if (result.value)
                                resolve(true);
                            else
                                reject();
                        }, function () {
                            messageService.error("common.genericError");
                        });
                    }
                    ;
                });
            };
            function newAccountSignIn() {
                //TODO - PBI - maybe move signIn into authService
                vm.loginData = {
                    checkout: true,
                    userName: vm.createAccount.email,
                    password: vm.createAccount.password,
                    tenantId: vm.frameworkData.tenant.id,
                    tenantCode: vm.frameworkData.tenant.code,
                    rememberMe: false
                };
                authService.login(vm.loginData).then(function () {
                    //console.log(response);
                    sessionService.init();
                    frameworkService.updateData();
                    shoppingCartService.synchronizeShoppingCart();
                    checkoutService.wizard.isStep1Valid = true;
                    $state.go("main.checkout.step2", {}, { location: "replace" });
                }, function (err) {
                    messageService.error(err);
                });
            }
            vm.submit = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    if (vm.createAccount.organizationId < 0) {
                        vm.createAccount.organizationId = null;
                    }
                    publicResource.saveCheckoutRegistration(vm.createAccount, function () {
                        vm.saving = false;
                        newAccountSignIn();
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
        }
    });
}());
